import React, { useState } from "react";
import { Box, Avatar, Dialog, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import BatteryStatusChip from "../layouts/Escort/BatteryStatusChip";
import { toast } from "react-toastify";
import apiClient from "Utils/apiClient";
import socketService from "socket/newsocketService";

const DialogBox = ({ userInfo, open, onClose }) => {
  const navigate = useNavigate();

  const [driverName, setDriverName] = useState("");

  const updateLastEscortDriverName = (value, nextDriverName) => {
    if (Array.isArray(value)) {
      const nextValue = [...value];
      const lastIndex = nextValue.length - 1;

      if (lastIndex >= 0) {
        nextValue[lastIndex] = {
          ...nextValue[lastIndex],
          DriverName: nextDriverName,
        };
      }

      return nextValue;
    }

    if (value && typeof value === "object") {
      const keys = Object.keys(value);
      const lastKey = keys[keys.length - 1];

      if (lastKey) {
        return {
          ...value,
          [lastKey]: {
            ...value[lastKey],
            DriverName: nextDriverName,
          },
        };
      }
    }

    return null;
  };

  const handelData = async () => {
    if (userInfo?.gsmMode && !driverName.trim()) {
      alert("Please enter Driver Name before starting Escort");
      return;
    }

    try {
      const userKey =
        userInfo?.userObjectKey ||
        userInfo?.userId ||
        userInfo?.id ||
        userInfo?._id?.toString?.() ||
        userInfo?._id;

      if (!userKey) {
        throw new Error("Missing user id for escort update");
      }

      const userResponse = await apiClient.get(`/users/${userKey}`);
      const userData = userResponse?.data;
      const updatePayload = {
        DriverName: driverName,
      };

      const nextEscortCollection = updateLastEscortDriverName(
        userData?.ShortDistance_Escort,
        driverName.trim(),
      );

      if (nextEscortCollection) {
        updatePayload.ShortDistance_Escort = nextEscortCollection;
      }

      // Firebase legacy flow kept for reference while the backend migration is active.
      // await update(ref(db, `users/${userKey}`), {
      //   DriverName: driverName,
      // });
      //
      // const escortRef = ref(db, `users/${userKey}/ShortDistance_Escort`);
      // const snapshot = await get(escortRef);
      //
      // if (snapshot.exists()) {
      //   const escorts = snapshot.val();
      //   const escortKeys = Object.keys(escorts);
      //   const lastEscortKey = escortKeys[escortKeys.length - 1];
      //   await update(ref(db, `users/${userKey}/ShortDistance_Escort/${lastEscortKey}`), {
      //     DriverName: driverName,
      //   });
      // }

      await apiClient.put(`/users/${userKey}`, updatePayload);

      toast.success("Escort details updated successfully", {
        autoClose: 2500,
        position: toast.POSITION.TOP_CENTER,
      });

      try {
        socketService.emit("shortdistanceescortadmin", {
          action: "update",
          userId: userKey,
          ...userInfo,
        });
      } catch (_) {}
      try {
        window.dispatchEvent(new CustomEvent("refreshEscortTable"));
      } catch (_) {}

      onClose();
      navigate("/escort");
    } catch (error) {
      console.error("Error updating driver name:", error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to update escort");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          width: 320,
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          backgroundColor: "#ffffff",
        }}
      >
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <Box sx={{ fontWeight: 700, fontSize: 18, color: "#d32f2f" }}>
            New Short Distance Escort Request
          </Box>
          <Box sx={{ fontSize: 13, color: "#6b7280", mt: 0.5 }}>
            Review the request details and continue to escort management.
          </Box>
        </Box>

        <Avatar
          alt="User Photo"
          src={userInfo?.imgVehicle || userInfo?.userImage}
          sx={{ width: 80, height: 80 }}
        />

        <Button
          variant="contained"
          fullWidth
          onClick={handelData}
          sx={{
            backgroundColor: "#d32f2f",
            color: "#ffffff",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#c62828" },
          }}
        >
          {userInfo?.gsmMode
            ? "Short Distance Vehicle Escort (GSM MODE)"
            : userInfo?.longDistanceEscort
            ? "Long Distance Escort Request"
            : userInfo?.isDriver || userInfo?.driverEscort || userInfo?.DriverName || userInfo?.driverId
            ? "Short Distance Driver Escort Request"
            : `Short Distance ${userInfo?.walking ? "Walking" : "Vehicle"} Escort Request`}
        </Button>

        <Box
          sx={{
            width: "100%",
            padding: 1,
            backgroundColor: "#00bcd4",
            color: "#ffffff",
            textAlign: "center",
            borderRadius: 1,
          }}
        >
          {userInfo?.userName}
        </Box>

        <Box
          sx={{
            width: "100%",
            padding: 1,
            backgroundColor: "#d32f2f",
            color: "#ffffff",
            textAlign: "center",
            borderRadius: 1,
          }}
        >
          {userInfo?.userPhoneP || userInfo?.userPhone}
        </Box>

        {(() => {
          const rawBat = userInfo?.BatteryIndicator ?? userInfo?.batteryLevel;
          const batNum = Number(rawBat);
          const normalizedBattery = Number.isFinite(batNum)
            ? (batNum <= 1 && batNum > 0 ? Math.round(batNum * 100) : Math.round(batNum))
            : 100;
          return <BatteryStatusChip status={normalizedBattery} />;
        })()}

        {userInfo?.gsmMode && (
          <>
            <Box
              sx={{
                width: "100%",
                padding: 1,
                backgroundColor: "#00bcd4",
                color: "#ffffff",
                textAlign: "center",
                borderRadius: 1,
                fontSize: "15px",
              }}
            >
              Driver's Number: {userInfo?.driverPhone}
            </Box>

            <TextField
              fullWidth
              size="small"
              label="Enter Driver Name"
              value={driverName}
              onChange={(e) => setDriverName(e.target.value)}
            />
          </>
        )}

        <Button
          onClick={handelData}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#000000",
            color: "#ffffff",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#333333" },
          }}
        >
          Escort
        </Button>
      </Box>
    </Dialog>
  );
};

export default React.memo(DialogBox);
